import { render } from "./WhyMe.vue?vue&type=template&id=4f2dbff6&scoped=true"
import script from "./WhyMe.vue?vue&type=script&lang=js"
export * from "./WhyMe.vue?vue&type=script&lang=js"

import "./WhyMe.vue?vue&type=style&index=0&id=4f2dbff6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f2dbff6"]])

export default __exports__